import { render } from "./NewsItemPage.vue?vue&type=template&id=7c2964aa&scoped=true"
import script from "./NewsItemPage.vue?vue&type=script&lang=js"
export * from "./NewsItemPage.vue?vue&type=script&lang=js"

import "./NewsItemPage.vue?vue&type=style&index=0&id=7c2964aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2964aa"]])

export default __exports__